import { values } from 'lodash';
import buildURL from 'axios/lib/helpers/buildURL';
import { compose, curriedPick } from '@core/lib/fp';

/**
 * Builds a full URL using the params and the configured serializer
 *
 * @param {AxiosRequestConfig} config
 * @returns {String}
 */
const buildFullURL = compose(args => buildURL(...args), values, curriedPick(['url', 'params', 'paramsSerializer']));

/**
 * Sorts the params in a given URL
 *
 * @param {String} url
 * @returns {String}
 */
const sortParams = url => {
  const [urlPath, queryString] = url.split('?');

  return queryString
    ? urlPath +
        '?' +
        queryString
          .split('&')
          .sort()
          .join('&')
    : url;
};

/**
 * Returns a full URL with all querystring params sorted to be used as
 * cache index
 *
 * @param {AxiosRequestConfig} config
 * @returns {String}
 * @private
 */
const buildCacheIndex = compose(sortParams, buildFullURL);

export default buildCacheIndex;
export { buildFullURL, sortParams, buildCacheIndex };
